// src/services/ForgotPasswordServices.js

import encryptData from "../config/encryptConfig";
import API_CONFIG from '../config/apiConfig';

// src/services/ForgotPasswordServices.js
export const forgotPassword = async ({ token, newPassword, confirmPassword }) => {
  try {
    const headers = {
      "Content-Type": "application/json"
    };

    const payload={
      token:encryptData(token),
      newPassword:encryptData(newPassword),
      confirmPassword:encryptData(confirmPassword)
    }

    const body = JSON.stringify(payload);



    const response = await fetch(
      `${API_CONFIG.BASE_URL}/auth/reset-password-with-token`,
      {
        method: "POST",
        headers: headers,
        body: body
      }
    );

    const data = await response.json();

    if (!response.ok) {
      throw new Error(data.message || "Failed to reset password");
    }

    return data;
  } catch (error) {
    throw error;
  }
};
